import { observer } from "mobx-react";
import React, { useContext, useState } from "react";

import { PlayerSortConfig } from "@data-types/sport-stats/SportStatsTypes";
import { EventContext, LookupContext } from "@gp/components";
import LivePlayerStatisticsStore from "@state/stores/offer/statistics/LivePlayerStatisticsStore";

import { GroupedPlayerStatsHeader } from "./GroupedPlayerStatsHeader";
import { PlayerStatsGroup } from "./PlayerStatsGroup";

export default observer(function GroupedPlayerStats(props: {
	store: LivePlayerStatisticsStore;
}) {
	const [isExpandedHomeHeader, setExpandHomeHeader] = useState(true);
	const [isExpandedAwayHeader, setExpandAwayHeader] = useState(true);

	const sortConfig: PlayerSortConfig = {
		key: "position",
		direction: "asc",
	};

	const homePlayers = props.store.filterPlayers(
		"home",
		props.store.playerFilter,
		sortConfig
	);
	const awayPlayers = props.store.filterPlayers(
		"away",
		props.store.playerFilter,
		sortConfig
	);

	const event = useContext(EventContext);
	const { teams } = useContext(LookupContext);
	const homeTeam = teams.get(event.teamOneId || "");
	const awayTeam = teams.get(event.teamTwoId || "");

	if (homeTeam == null || awayTeam == null) {
		console.error("Expected teams, got one or more null.");
		return null;
	}

	const activeGroup = props.store.playerStatsGroups.find(
		(group) => group.key === props.store.playerFilter
	);

	const teamsConfig = [
		{
			isExpandedHeader: isExpandedHomeHeader,
			setExpandHeader: setExpandHomeHeader,
			teamName: homeTeam.name,
			players: homePlayers,
		},
		{
			isExpandedHeader: isExpandedAwayHeader,
			setExpandHeader: setExpandAwayHeader,
			teamName: awayTeam.name,
			players: awayPlayers,
		},
	];

	return (
		<div className="event__content">
			{teamsConfig.map((config) => (
				<div
					className={
						"offer offer--additional" +
						(config.isExpandedHeader
							? " is-expanded"
							: " is-collapsed")
					}
				>
					<GroupedPlayerStatsHeader
						isExpanded={config.isExpandedHeader}
						onSetExpand={config.setExpandHeader}
						title={config.teamName}
					/>

					<div className="offer__body offer--additional__body">
						<div className="card--stats card--stats--borderless">
							<div className="card--stats__body u-gap--reset u-padd--reset">
								{config.players.map(
									(player) =>
										activeGroup && (
											<PlayerStatsGroup
												isExpandedHeader={
													config.isExpandedHeader
												}
												key={player.name}
												player={player}
												statsGroup={activeGroup}
											/>
										)
								)}
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
});
